<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card elevation="0">
				<v-card-text>
					<v-chip-group active-class="primary--text" column>
						<v-chip v-for="(favorit, index) in favorits" :key="index" 
							close
							@click:close="removeFavorit(favorit)"
							@click="onFavorit(favorit)"
						>
						{{ favorit.name }}
						</v-chip>
					</v-chip-group>
					<!-- <z-vehicle-parameters-number></z-vehicle-parameters-number> -->
					<z-vehicle-parameters ref="parameters" yearProdPeriod visibleAdverts></z-vehicle-parameters>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<!-- <z-right-side-control></z-right-side-control> -->
		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon large color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card elevation="0">
				<v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-divider></v-divider>

				<v-card-text v-for="(estimate, index) in estimates" :key="index">
					<z-form-average-price-ai :estimate="estimate" visible-adverts></z-form-average-price-ai>
				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
//import zVehicleParametersNumber from '@/views/forms/vehicle.parameters.number'
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zRightSideControl from '@/views/components/drawer/RightSideControl'
import zPdf from '@/views/pdf/VehicleAveragePriceAI'
import downloadExcel from "vue-json-excel";
import zFormAveragePriceAi from '@/views/forms/VehicleAveragePriceAI'

export default {
	name: 'VehicleAveragePriceAI',
	mixins: [mixin],
	components: {
		//zVehicleParametersNumber,
		zVehicleParameters,
		zRightSideControl,
		zPdf,
		downloadExcel,
		zFormAveragePriceAi,
	},
	data: () => ({
		title: 'Середня ціна з використанням AI',
		subtitle: 'Визначення середньої ціни із застосуванням технології AI',
		loading: false,

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),

	computed: {
		...mapGetters('VehicleAveragePriceAI', [ 'item' ]),

		/* ...mapGetters('VehicleEstimate', [
			'params', 'item', 'isset'
		]), */

		excelName() {
			return this.title + (this.params.number ? ' ' + this.params.number : (this.params.vin ? ' ' + this.params.vin : '') + '.' +  this.excel.type)
		},

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		},
	},

	methods: {
		...mapActions('VehicleAveragePriceAI', [ 'setItem' ]),

		/* ...mapActions('VehicleEstimate', [
			'setItem', 'clear'
		]), */

		onClear() {
			this.$refs.parameters.reset()
			//this.clear()
		},

		/* validate() {
			//return true
			return this.params.number 
				|| this.params.vin
				|| this.params.brand
				|| this.params.model
		}, */

		onOK() {
			if(this.$refs.parameters.validate()) {
			//if(this.validate()) {
				this.loading = true
				var that = this
				axios.post('/vehicle/estimate/averageprice/ai', this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}
</script>